import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const PublicHeader = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { label: 'Home', path: '/home-page' },
    { label: 'Newsletter Archive', path: '/newsletter-archive' },
  ];

  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  const handleSubscribeClick = () => {
    const subscribeSection = document.getElementById('subscribe-section');
    if (subscribeSection) {
      subscribeSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-[100] bg-card border-b border-border shadow-elevation-sm">
        <div className="flex items-center justify-between h-[60px] px-5 lg:px-8">
          <Link 
            to="/home-page" 
            className="flex items-center gap-3 hover:opacity-80 transition-opacity duration-250"
            onClick={closeMobileMenu}
          >
            <img 
              src="/assets/images/LOGO_THEPS_WHITE-1763891008145.png" 
              alt="THEPS logo featuring handshake symbol in light gray within a circle, surrounded by twelve stars representing international partnership and cooperation"
              className="h-10 w-auto object-contain"
            />
            <span className="text-xl font-heading font-semibold text-foreground">
              THEPS Newsletter
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`text-sm font-medium transition-colors duration-250 hover:text-accent ${
                  isActivePath(item?.path)
                    ? 'text-primary border-b-2 border-primary pb-1' :'text-foreground'
                }`}
              >
                {item?.label}
              </Link>
            ))}
            <Button
              variant="default"
              size="default"
              onClick={handleSubscribeClick}
              className="bg-accent hover:bg-accent/90 text-accent-foreground"
            >
              Subscribe
            </Button>
          </nav>

          <button
            onClick={toggleMobileMenu}
            className="lg:hidden flex items-center justify-center w-10 h-10 text-foreground hover:bg-muted rounded-lg transition-colors duration-250"
            aria-label="Toggle mobile menu"
            aria-expanded={isMobileMenuOpen}
          >
            <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
          </button>
        </div>

        <div
          className={`lg:hidden overflow-hidden transition-all duration-300 ease-smooth ${
            isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <nav className="flex flex-col gap-1 px-5 py-4 bg-muted/50 border-t border-border">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                onClick={closeMobileMenu}
                className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-250 ${
                  isActivePath(item?.path)
                    ? 'bg-primary text-primary-foreground'
                    : 'text-foreground hover:bg-muted'
                }`}
              >
                {item?.label}
              </Link>
            ))}
            <Button
              variant="default"
              size="default"
              onClick={handleSubscribeClick}
              fullWidth
              className="mt-2 bg-accent hover:bg-accent/90 text-accent-foreground"
            >
              Subscribe
            </Button>
          </nav>
        </div>
      </header>
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 z-[90] bg-foreground/20 backdrop-blur-sm lg:hidden animate-fade-in"
          onClick={closeMobileMenu}
          aria-hidden="true"
        />
      )}
    </>
  );
};

export default PublicHeader;